'use strict';

angular.module('scrapQcrmApp')
  .controller('TelecallersCtrl', function($scope, tableState, $uibModal, telecallerService, growl, $rootScope, $global, $state) {

    $scope.telecallers  = [];
    $scope.loading      = false;
    $scope.currentPage  = 1;
    $scope.pageSize     = 10;
    $scope.totalCount   = 0;
    $scope.statusFilter = '';
    $scope.searchText   = '';

    // ─── Load ────────────────────────────────────────────────────────────────

    $scope.loadTelecallers = function() {
      $scope.loading = true;
      var city   = $rootScope.loginData ? $rootScope.loginData.city : '';
      var page   = $scope.currentPage - 1;
      var status = $scope.statusFilter || undefined;

      telecallerService.getTelecallerList(city, page, status)
        .then(function(res) {
          if (res.statusCode === 200 || res.status === 'Success' || res.status === 'SUCCESS') {
            var all = (res.data && res.data.telecallers) ? res.data.telecallers : [];
            if (!all.length && $scope.currentPage > 1) {
              // page gone (e.g. an old link): first page
              $scope.currentPage = 1;
              $scope.loadTelecallers();
              return;
            }
            $scope.totalCount = (res.data && res.data.totalCount) ? res.data.totalCount : all.length;
            $scope.applySearch(all);
          } else {
            growl.error(res.message || 'Failed to load telecallers');
          }
        })
        .catch(function(err) {
          console.error('Load telecallers error:', err);
          growl.error('Failed to load telecallers');
        })
        .finally(function() { $scope.loading = false; });
    };

    // ─── Search ───────────────────────────────────────────────────────────────

    $scope.applySearch = function(list) {
      if ($scope.searchText && $scope.searchText.trim()) {
        var q = $scope.searchText.toLowerCase().trim();
        $scope.telecallers = list.filter(function(t) {
          return (t.name    && t.name.toLowerCase().indexOf(q)    !== -1) ||
                 (t.mobileNo && t.mobileNo.indexOf(q)             !== -1);
        });
      } else {
        $scope.telecallers = list;
      }
    };

    $scope.searchTelecallers = function() {
      $scope.currentPage = 1;
      $scope.loadTelecallers();
    };

    $scope.clearSearch = function() {
      $scope.searchText = '';
      $scope.currentPage = 1;
      $scope.loadTelecallers();
    };

    // Enter key on search input
    $scope.onSearchKeydown = function($event) {
      if ($event.keyCode === 13) { $scope.searchTelecallers(); }
    };

    $scope.filterByStatus = function() {
      $scope.currentPage = 1;
      $scope.loadTelecallers();
    };

    // ─── Add / Edit modal ────────────────────────────────────────────────────

    $scope.addTelecaller = function() { $scope.openModal(null); };

    $scope.editTelecaller = function(telecaller) { $scope.openModal(telecaller); };

    $scope.openModal = function(telecallerData) {
      var modal = $uibModal.open({
        templateUrl: 'views/add-telecaller.html',
        controller:  'AddTelecallerCtrl',
        size:        'md',
        resolve: { telecallerData: function() { return telecallerData || null; } }
      });
      modal.result.then(function() {
        // If the edited record is the currently logged-in telecaller,
        // re-read loginData from localStorage so header reflects latest name/mobile
        if (telecallerData && $rootScope.loginData &&
            $rootScope.loginData.userid === telecallerData.telecallerId) {
          $rootScope.loginData = $global.getLocalItem('loginData', true);
        }
        $scope.loadTelecallers();
      }).catch(angular.noop);
    };

    // ─── Toggle active / inactive ────────────────────────────────────────────

    $scope.toggleStatus = function(telecaller) {
      var isActive = telecaller.status;
      var action   = isActive ? 'disable' : 'enable';
      var label    = isActive ? 'Disable' : 'Enable';

      if (!confirm(label + ' ' + telecaller.name + '?')) { return; }

      var call = isActive
        ? telecallerService.disableTelecaller(telecaller.telecallerId)
        : telecallerService.enableTelecaller(telecaller.telecallerId);

      call.then(function(res) {
        if (res.statusCode === 200 || res.status === 'Success' || res.status === 'SUCCESS') {
          growl.success('Telecaller ' + action + 'd successfully');
          $scope.loadTelecallers();
        } else {
          growl.error(res.message || 'Failed to ' + action + ' telecaller');
        }
      }).catch(function() {
        growl.error('Failed to ' + action + ' telecaller');
      });
    };

    // ─── Delete ──────────────────────────────────────────────────────────────

    $scope.deleteTelecaller = function(telecaller) {
      if (!confirm('Permanently delete ' + telecaller.name + '? This cannot be undone.')) { return; }

      telecallerService.deleteTelecaller(telecaller.telecallerId)
        .then(function(res) {
          if (res.statusCode === 200 || res.status === 'Success' || res.status === 'SUCCESS') {
            growl.success('Telecaller deleted');

            // If the deleted telecaller is the currently logged-in user, clear session and logout
            if ($rootScope.loginData && $rootScope.loginData.userid === telecaller.telecallerId) {
              $global.removeLocalItem('authentication');
              $global.removeLocalItem('loginData');
              $global.init();
              $state.go('login');
              return;
            }

            $scope.loadTelecallers();
          } else {
            growl.error(res.message || 'Failed to delete telecaller');
          }
        }).catch(function() {
          growl.error('Failed to delete telecaller');
        });
    };

    // ─── Reset password ──────────────────────────────────────────────────────

    $scope.resetPassword = function(telecaller) {
      var pwd = prompt('New password for ' + telecaller.name + ':');
      if (!pwd || !pwd.trim()) { return; }
      if (pwd.length < 4) { growl.error('Password too short (min 4 characters)'); return; }

      telecallerService.resetPassword(telecaller.telecallerId, pwd)
        .then(function(res) {
          if (res.statusCode === 200 || res.status === 'Success' || res.status === 'SUCCESS') {
            growl.success('Password reset successfully');
          } else {
            growl.error(res.message || 'Failed to reset password');
          }
        }).catch(function() {
          growl.error('Failed to reset password');
        });
    };

    // ─── Pagination ──────────────────────────────────────────────────────────

    $scope.nextPage = function() {
      if ($scope.telecallers.length === $scope.pageSize) {
        $scope.currentPage++;
        $scope.loadTelecallers();
      }
    };

    $scope.prevPage = function() {
      if ($scope.currentPage > 1) {
        $scope.currentPage--;
        $scope.loadTelecallers();
      }
    };

    // ─── Helpers ─────────────────────────────────────────────────────────────

    $scope.getStatusClass = function(status) { return status ? 'label-success' : 'label-danger'; };
    $scope.getStatusText  = function(status) { return status ? 'Active' : 'Inactive'; };
    $scope.getToggleTitle = function(status) { return status ? 'Disable' : 'Enable'; };
    $scope.getToggleClass = function(status) { return status ? 'btn-warning' : 'btn-success'; };
    $scope.getToggleIcon  = function(status) { return status ? 'fa-toggle-off' : 'fa-toggle-on'; };

    $scope.formatDate = function(ts) {
      if (!ts) { return '-'; }
      return new Date(parseInt(ts)).toLocaleDateString();
    };

    // ─── Init ────────────────────────────────────────────────────────────────

    // search, status and page are kept in the URL, so Back / refresh show the same list
    var reloadQueued = false;
    function reloadSoon() {
      if (!reloadQueued) {
        reloadQueued = true;
        $scope.$evalAsync(function() {
          reloadQueued = false;
          $scope.loadTelecallers();
        });
      }
    }
    tableState.page($scope, 't', {
      controls: {
        q: { model: 'searchText', type: 'string', history: 'search', onRestore: reloadSoon },
        s: { model: 'statusFilter', type: 'string', validate: function(v) { return v === 'true' || v === 'false'; }, onRestore: reloadSoon },
        p: { model: 'currentPage', type: 'int', history: 'replace', validate: function(v) { return v >= 1; }, onRestore: reloadSoon }
      }
    });

    $scope.loadTelecallers();
  });
